import * as React from "react"

import { cn } from "../utils"

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(
  ({ className, value, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "border-input placeholder:text-input-placeholder focus-visible:border-ring flex min-h-[60px] w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        value={value === null ? "" : value}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
